const Builder = require('../BuilderBase');
const Layout = require('../Layout');

module.exports = class ElementGroups extends Builder {
    constructor(title, properties) {
        super('formElement_ElementGroups', title, properties);
        if (!properties.propertyName) {
            throw new Error(
                `${title} does not have a 'propertyName'.  You must pass a 'propertyName' value in properties when creating formElements.`
            );
        }
    }

    layout(title) {
        if (!title) {
            throw new Error('You must specify a `title` for the layout');
        }
        const layout = new Layout(title);
        this.addChildBlock(layout, 'optionGroups');
        return layout;
    }
};
